// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================== */
/*        SCSS VARS       */
/* ===================== */
/* ===================== */
/*      CSS VARIABLES     */
/* ===================== */
:root {
  /* Text */
  --base-text-color: #1D1D1D;
  --darker-text-color: #202020;
  --brighter-text-color: #696969;
  /* UI */
  --base-ui-color: #1351F1;
  --warning-ui-color: #F8A01E;
  --secondary-ui-color: #E8E4E4;
  /* Background */
  --base-bg-color: #F5F5F5;
  /* Grays */
  --color-gray: #B2B2B2;
  --color-gray-2: #9E9E9E;
  --color-gray-3: #D8D8D8;
  --color-dark-gray: #676767;
  /* Fonts */
  --main-font: Noto Sans;
  --secondary-font: Roboto;
  --third-font: Open Sans;
  --fourth-font: Dosis;
  /* Error */
  --error-color: #E00000;
  /* Border */
  --border-color: #D8D8D8;
}

.fk-layout .fk-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.fk-layout .fk-header .menu-container {
  display: flex;
  flex-direction: row;
}
.fk-layout .fk-header .menu-container .logo {
  max-height: 100px;
}
.fk-layout .fk-header .menu-container .menu {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0 0 0 30px;
  padding: 0;
}
.fk-layout .fk-header .menu-container .menu .menu-link {
  display: inline-block;
  text-align: center;
  font-size: 20px;
  line-height: 36px;
  margin: 0 20px;
  padding-bottom: 4px;
}
.fk-layout .fk-header .menu-container .menu .menu-link a {
  color: #9E9E9E;
  font-weight: normal;
  font-family: "Noto Sans";
  cursor: pointer;
}
.fk-layout .fk-header .menu-container .menu .menu-link a:hover {
  text-decoration: none;
}
.fk-layout .fk-header .menu-container .menu .menu-link:hover, .fk-layout .fk-header .menu-container .menu .menu-link.active {
  padding-bottom: 0;
  border-bottom: 3px solid #1351F1;
  margin: 0 17px;
}
.fk-layout .fk-header .menu-container .menu .menu-link:hover a, .fk-layout .fk-header .menu-container .menu .menu-link.active a {
  font-weight: bold;
  color: #1351F1;
}
.fk-layout .fk-header .account-menu {
  display: flex;
  flex-direction: column;
}
.fk-layout .fk-header .account-menu .user-name {
  font-size: 14px;
  font-weight: bold;
  font-family: "Dosis";
  color: #434343;
}
.fk-layout .fk-header .account-menu .user-email {
  font-size: 12px;
  font-family: "Dosis";
  color: #B9B9B9;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/layout/layout.styles.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA,2BAAA;AACA,0BAAA;AA2BA,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,SAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EAEA,OAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,eAAA;EACA,wBAAA;EAEA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EAEA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,UAAA;EACA,sBAAA;EAEA,WAAA;EACA,uBAAA;AChCF;;AA5BI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AA+BR;AA7BQ;EACI,aAAA;EACA,mBAAA;AA+BZ;AA7BY;EACI,iBAAA;AA+BhB;AA5BY;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AA8BhB;AA5BgB;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AA8BpB;AA5BoB;EACI,cDnBT;ECoBS,mBAAA;EACA,wBDjBZ;ECkBY,eAAA;AA8BxB;AA5BwB;EACI,qBAAA;AA8B5B;AA1BoB;EAEI,iBAAA;EACA,gCAAA;EACA,cAAA;AA2BxB;AAzBwB;EACI,iBAAA;EACA,cD5CZ;ACuEhB;AApBQ;EACI,aAAA;EACA,sBAAA;AAsBZ;AApBY;EACI,eAAA;EACA,iBAAA;EACA,oBD5CF;EC6CE,cAAA;AAsBhB;AAnBY;EACI,eAAA;EACA,oBDlDF;ECmDE,cAAA;AAqBhB","sourcesContent":["/* ===================== */\n/*        SCSS VARS       */\n/* ===================== */\n\n$base-text-color: #1D1D1D;\n$darker-text-color: #202020;\n$brighter-text-color: #696969;\n\n$base-ui-color: #1351F1;\n$warning-ui-color: #F8A01E;\n$secondary-ui-color: #E8E4E4;\n\n$base-bg-color: #F5F5F5;\n\n$color-gray: #B2B2B2;\n$color-gray-2: #9E9E9E;\n$color-gray-3: #D8D8D8;\n$color-dark-gray: #676767;\n\n$main-font: \"Noto Sans\";\n$secondary-font: \"Roboto\";\n$third-font: \"Open Sans\";\n$fourth-font: \"Dosis\";\n\n$error-color: #E00000; // #ff1744\n\n$border-color: #D8D8D8;\n\n\n/* ===================== */\n/*      CSS VARIABLES     */\n/* ===================== */\n\n:root {\n  /* Text */\n  --base-text-color: #{$base-text-color};\n  --darker-text-color: #{$darker-text-color};\n  --brighter-text-color: #{$brighter-text-color};\n\n  /* UI */\n  --base-ui-color: #{$base-ui-color};\n  --warning-ui-color: #{$warning-ui-color};\n  --secondary-ui-color: #{$secondary-ui-color};\n\n  /* Background */\n  --base-bg-color: #{$base-bg-color};\n\n  /* Grays */\n  --color-gray: #{$color-gray};\n  --color-gray-2: #{$color-gray-2};\n  --color-gray-3: #{$color-gray-3};\n  --color-dark-gray: #{$color-dark-gray};\n\n  /* Fonts */\n  --main-font: #{$main-font};\n  --secondary-font: #{$secondary-font};\n  --third-font: #{$third-font};\n  --fourth-font: #{$fourth-font};\n\n  /* Error */\n  --error-color: #{$error-color};\n\n  /* Border */\n  --border-color: #{$border-color};\n}","@import '../../styles/variables';\n\n.fk-layout {\n    .fk-header {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0 20px;\n\n        .menu-container {\n            display: flex;\n            flex-direction: row;\n\n            .logo {\n                max-height: 100px;\n            }\n\n            .menu {\n                display: flex;\n                align-items: center;\n                list-style: none;\n                margin: 0 0 0 30px;\n                padding: 0;\n\n                .menu-link {\n                    display: inline-block;\n                    text-align: center;\n                    font-size: 20px;\n                    line-height: 36px;\n                    margin: 0 20px;\n                    padding-bottom: 4px;\n\n                    a {\n                        color: $color-gray-2;\n                        font-weight: normal;\n                        font-family: $main-font;\n                        cursor: pointer;\n\n                        &:hover {\n                            text-decoration: none;\n                        }\n                    }\n\n                    &:hover,\n                    &.active {\n                        padding-bottom: 0;\n                        border-bottom: 3px solid $base-ui-color;\n                        margin: 0 17px;\n\n                        a {\n                            font-weight: bold;\n                            color: $base-ui-color;\n                        }\n                    }\n                }\n            }\n        }\n\n        .account-menu {\n            display: flex;\n            flex-direction: column;\n\n            .user-name {\n                font-size: 14px;\n                font-weight: bold;\n                font-family: $fourth-font;\n                color: #434343;\n            }\n\n            .user-email {\n                font-size: 12px;\n                font-family: $fourth-font;\n                color: #B9B9B9;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
